/* Recherche predictive de l'entete. Interroge /search/suggest.json en
   frappe (250 ms de debounce), liste au plus cinq produits en liens.
   Ferme sur Echap et clic dehors ; le focus revient au bouton loupe.
   Toute erreur reseau laisse le formulaire natif faire le travail. */
(function () {
  'use strict';

  /* L'editeur de theme remplace le DOM de l'en-tete a chaque reglage
     (shopify:section:load) : les references figees a l'init pointeraient
     sur des noeuds detaches. L'init est donc rejouable, marquee sur la
     racine, et ses listeners document se retirent quand la racine sort. */
  function initialiser() {
  var racine = document.querySelector('[data-vd-recherche]');
  if (!racine || racine.dataset.vdRechercheActif) return;
  racine.dataset.vdRechercheActif = 'true';
  var bouton = racine.querySelector('[data-vd-recherche-ouvrir]');
  var panneau = racine.querySelector('[data-vd-recherche-panneau]');
  var champ = racine.querySelector('[data-vd-recherche-champ]');
  var liste = racine.querySelector('[data-vd-recherche-resultats]');
  var annonce = racine.querySelector('[data-vd-recherche-annonce]');
  if (!bouton || !panneau || !champ || !liste) return;

  var minuterie = null;
  var derniereRequete = 0;

  function ouvrir() {
    panneau.hidden = false;
    bouton.setAttribute('aria-expanded', 'true');
    champ.focus();
  }

  function fermer() {
    panneau.hidden = true;
    bouton.setAttribute('aria-expanded', 'false');
    liste.hidden = true;
    liste.textContent = '';
  }

  function rendre(produits) {
    liste.textContent = '';
    produits.forEach(function (produit) {
      var item = document.createElement('li');
      var lien = document.createElement('a');
      lien.className = 'recherche__resultat';
      lien.href = produit.url;
      var nom = document.createElement('span');
      nom.className = 'recherche__resultat-nom';
      nom.textContent = produit.title;
      lien.appendChild(nom);
      if (produit.price) {
        var prix = document.createElement('span');
        prix.className = 'recherche__resultat-prix';
        /* suggest.json rend un decimal brut (2.50) : affichage a la
           francaise, sans dependre du money_format absent ici. */
        prix.textContent = String(produit.price).replace('.', ',') + ' €';
        lien.appendChild(prix);
      }
      item.appendChild(lien);
      liste.appendChild(item);
    });
    liste.hidden = produits.length === 0;
    if (annonce) {
      annonce.textContent = liste.hidden
        ? (racine.getAttribute('data-libelle-aucun') || '')
        : (racine.getAttribute(produits.length === 1 ? 'data-libelle-resultat' : 'data-libelle-resultats') || '').replace('__COUNT__', String(produits.length));
    }
  }

  function chercher(terme) {
    var horodatage = Date.now();
    derniereRequete = horodatage;
    /* Route fournie par le snippet (routes.predictive_search_url) : elle
       porte le prefixe de locale que l'URL en dur ignorerait. */
    var base = racine.getAttribute('data-url-suggest') || '/search/suggest';
    var url = base + '.json?q=' + encodeURIComponent(terme)
      + '&resources[type]=product&resources[limit]=5';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (reponse) {
        if (!reponse.ok) throw new Error('suggest ' + reponse.status);
        return reponse.json();
      })
      .then(function (donnees) {
        if (horodatage !== derniereRequete) return;
        var produits = donnees
          && donnees.resources
          && donnees.resources.results
          && donnees.resources.results.products
          ? donnees.resources.results.products
          : [];
        rendre(produits);
      })
      .catch(function (erreur) {
        console.error('[vd-recherche] suggestion indisponible', erreur);
        liste.hidden = true;
      });
  }

  bouton.addEventListener('click', function () {
    if (panneau.hidden) ouvrir();
    else fermer();
  });

  champ.addEventListener('input', function () {
    window.clearTimeout(minuterie);
    var terme = champ.value.trim();
    if (terme.length < 2) {
      derniereRequete = 0;
      liste.hidden = true;
      liste.textContent = '';
      return;
    }
    minuterie = window.setTimeout(function () {
      chercher(terme);
    }, 250);
  });

  function surTouche(evt) {
    if (!document.contains(racine)) {
      document.removeEventListener('keydown', surTouche);
      return;
    }
    if (evt.key === 'Escape' && !panneau.hidden) {
      fermer();
      bouton.focus();
    }
  }

  function surClicDocument(evt) {
    if (!document.contains(racine)) {
      document.removeEventListener('click', surClicDocument);
      return;
    }
    if (!panneau.hidden && !racine.contains(evt.target)) fermer();
  }

  document.addEventListener('keydown', surTouche);
  document.addEventListener('click', surClicDocument);
  }

  initialiser();
  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target && evt.target.querySelector && evt.target.querySelector('[data-vd-recherche]')) {
      initialiser();
    }
  });
})();